import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AlertaService } from "../../services/alerta.service";
import { catchError, exhaustMap, map, tap } from "rxjs/operators";
import { of } from "rxjs";
import { findCostsPerEmployeeGroupAct, loadCostsPerEmployeeGroupByIdAct, saveCostsPerEmployeeGroupAct, saveSuccessCostsPerEmployeeGroupAct, 
    setViolationsCostsPerEmployeeGroupAct, showMsgErrorAct, updateCostsPerEmployeeGroupAct, updateSuccessCostsPerEmployeeGroupAct } from "./cost-per-employee-group.action";
import { CostsPerEmployeeGroupService } from "../../services/cost-per-employee-group.service";


@Injectable()
export class CostsPerEmployeeGroupEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private costsPerEmployeeGroupService = inject(CostsPerEmployeeGroupService);
    private alerta = inject(AlertaService);

    findCostsPerEmployeeGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findCostsPerEmployeeGroupAct),
            exhaustMap(action => this.costsPerEmployeeGroupService.findCostsPerEmployeeGroupById(action.id)
                .pipe(
                    map(costsPerEmployeeGroup => loadCostsPerEmployeeGroupByIdAct({ costsPerEmployeeGroup })),
                    catchError(error => {
                        if(error.status == 500) {
                            this.alerta.error("Se ha precentado un error interno", {
                                detail: error.error.details ,
                                onAccept: () => {
                                  this.router.navigate(['/costsPerEmployeesGroup']);
                                }}); // . stack -> mas detalle
                            return of();
                        }else {
                            //return of(showMsgErrorAct({ error }));
                            this.alerta.error("Se ha precentado un error interno: ", {detail: error.message});
                            return of();
                        }
                    })
                ))
        )
    );

    saveCostsPerEmployeeGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveCostsPerEmployeeGroupAct),
            exhaustMap(action => this.costsPerEmployeeGroupService.createCostsPerEmployeeGroup(action.costsPerEmployeeGroupNew)
                .pipe(
                    map(costsPerEmployeeGroupNew => saveSuccessCostsPerEmployeeGroupAct({ costsPerEmployeeGroupNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsCostsPerEmployeeGroupAct({ costsPerEmployeeGroupForm: action.costsPerEmployeeGroupNew, violations: this.violationsToObject(error.error.parameterViolations) })) 
                    : of(showMsgErrorAct({ error }))
                    
                    )
                )
            )
        )
    );

    showMsgErrorEffect$ = createEffect(() =>
        this.actions$.pipe(
          ofType(showMsgErrorAct),
          tap(action => {
            const detail = action.error?.error?.message || action.error?.message || null;
            //console.log('showMsgErrorEffect 111:');
            this.alerta.error(
              'Se ha presentado un error interno Grupo Beneficios',
              detail ? { detail } : undefined
            );
            //console.log('showMsgErrorEffect 222:');
          })
        ),
        { dispatch: false }
      );

    saveSuccessCostsPerEmployeeGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessCostsPerEmployeeGroupAct),
        tap(() => {
            this.router.navigate(['/costsPerEmployeesGroup']);
            this.alerta.correct("Grupo Beneficios creado con exito!");
        })
    ), { dispatch: false });

    updateCostsPerEmployeeGroupEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateCostsPerEmployeeGroupAct),
            exhaustMap(action => this.costsPerEmployeeGroupService.updateCostsPerEmployeeGroup(action.costsPerEmployeeGroupUpdated)
                .pipe(
                    map(costsPerEmployeeGroupUpdated => updateSuccessCostsPerEmployeeGroupAct({ costsPerEmployeeGroupUpdated })),
                    catchError(error => {
                        if(error.status == 400) {
                            return of(setViolationsCostsPerEmployeeGroupAct({ costsPerEmployeeGroupForm: action.costsPerEmployeeGroupUpdated, violations: this.violationsToObject(error.error.parameterViolations)})) ;
                        }else {
                            return of(showMsgErrorAct({ error }));
                        }
                    })
                )
            )
        )
    );

    updateSuccessCostsPerEmployeeGroupEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessCostsPerEmployeeGroupAct),
        tap(() => {
            this.router.navigate(['/costsPerEmployeesGroup']);
            this.alerta.correct("rupo Beneficios editado con exito!");
        })
    ), {dispatch: false});

    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
    
}